<template>
  <div class="container">
    <StarConditionLayout>
      <StarConditionCell label="站点名称">
        <a-input style="width: 100%"> </a-input>
      </StarConditionCell>

      <StarConditionCell label="站点名称">
        <a-input style="width: 100%"> </a-input>
      </StarConditionCell>

      <StarConditionCell label="站点名称">
        <a-input style="width: 100%"> </a-input>
      </StarConditionCell>

      <StarConditionCell label="站点名称">
        <a-input style="width: 100%"> </a-input>
      </StarConditionCell>

      <StarConditionCell label="站点名称">
        <a-input style="width: 100%"> </a-input>
      </StarConditionCell>
    </StarConditionLayout>

    <div class="skeleton-container">
      <a-skeleton active avatar :paragraph="{ rows: 4 }" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.container {
  padding: 16px;

  .skeleton-container {
    width: 100%;
    background: white;
    margin-top: 16px;
    padding: 16px;
  }
}
</style>